/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttachMeetingToProcessRequestDto } from '../models';
// @ts-ignore
import type { ChangeMeetingOwnerRequestDto } from '../models';
// @ts-ignore
import type { MeetingDayDto } from '../models';
// @ts-ignore
import type { MeetingDetailsDto } from '../models';
// @ts-ignore
import type { MeetingEventsDto } from '../models';
// @ts-ignore
import type { MeetingFeedbackDto } from '../models';
// @ts-ignore
import type { MeetingFeedbackRequestDto } from '../models';
// @ts-ignore
import type { MeetingFeedbacksDto } from '../models';
// @ts-ignore
import type { MeetingNoteDeliveriesDto } from '../models';
// @ts-ignore
import type { MeetingNoteDto } from '../models';
// @ts-ignore
import type { MeetingNotePartsDto } from '../models';
// @ts-ignore
import type { MeetingNotePartsPreviewRequestDto } from '../models';
// @ts-ignore
import type { MeetingOrganizersSearchResponseDto } from '../models';
// @ts-ignore
import type { MeetingStatusDto } from '../models';
// @ts-ignore
import type { MeetingTranscriptDto } from '../models';
// @ts-ignore
import type { MeetingTypeDto } from '../models';
// @ts-ignore
import type { MeetingsImportResultDto } from '../models';
// @ts-ignore
import type { MeetingsSearchResponseDto } from '../models';
// @ts-ignore
import type { MeetingsSortByDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { UpdateMeetingNoteRequestDto } from '../models';
/**
 * MeetingsRestApi - axios parameter creator
 */
export const MeetingsRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add recruiter feedback to a meeting
         * @param {number} meetingId 
         * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMeetingFeedback: async (meetingId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('addMeetingFeedback', 'meetingId', meetingId)
            // verify required parameter 'meetingFeedbackRequestDto' is not null or undefined
            assertParamExists('addMeetingFeedback', 'meetingFeedbackRequestDto', meetingFeedbackRequestDto)
            const localVarPath = `/api/v1/meetings/{meetingId}/feedbacks`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingFeedbackRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fallback for a meeting the title marker or the eRecruiter link did not connect. Sets the process, the meeting type and, when missing, the eRecruiter recruitment id of the process. 
         * @summary Attach a meeting that has no process to a process by hand
         * @param {number} meetingId 
         * @param {AttachMeetingToProcessRequestDto} attachMeetingToProcessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachMeetingToProcess: async (meetingId: number, attachMeetingToProcessRequestDto: AttachMeetingToProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('attachMeetingToProcess', 'meetingId', meetingId)
            // verify required parameter 'attachMeetingToProcessRequestDto' is not null or undefined
            assertParamExists('attachMeetingToProcess', 'attachMeetingToProcessRequestDto', attachMeetingToProcessRequestDto)
            const localVarPath = `/api/v1/meetings/{meetingId}/process-link`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachMeetingToProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The owner is the recruiter who organised the meeting. Only the current owner or an administrator can change it; a meeting without an owner can be taken over by any user. 
         * @summary Hand the meeting and its note over to another recruiter
         * @param {number} meetingId 
         * @param {ChangeMeetingOwnerRequestDto} changeMeetingOwnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMeetingOwner: async (meetingId: number, changeMeetingOwnerRequestDto: ChangeMeetingOwnerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('changeMeetingOwner', 'meetingId', meetingId)
            // verify required parameter 'changeMeetingOwnerRequestDto' is not null or undefined
            assertParamExists('changeMeetingOwner', 'changeMeetingOwnerRequestDto', changeMeetingOwnerRequestDto)
            const localVarPath = `/api/v1/meetings/{meetingId}/owner`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeMeetingOwnerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get meeting details
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeeting: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeeting', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the notes, the feedback and the transcript as one PDF
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingDocumentPdf: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingDocumentPdf', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/document/pdf`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bot and system activity recorded for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingEvents: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingEvents', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/events`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the recruiter feedback left for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingFeedbacks: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingFeedbacks', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/feedbacks`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the latest AI note for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNote: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingNote', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/note`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What was actually sent to eRecruiter, per send
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNoteDeliveries: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingNoteDeliveries', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/deliveries`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the parts the note would be delivered in, each one with the marker it will carry and its length, so a recruiter sees what lands in eRecruiter before anything is sent. 
         * @summary The stored note split exactly the way a send would split it
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNoteParts: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingNoteParts', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/note/parts`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a meeting note as PDF
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNotePdf: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingNotePdf', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/note/pdf`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get meeting transcript (readable text + segments)
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingTranscript: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingTranscript', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/transcript`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The people who created the meetings, taken from the calendar invitations, one entry per address and display name, sorted by surname ascending. Feeds the organizer drop-down on the meetings list, so it is paginated and searchable: a phrase shorter than two characters is ignored and the whole list comes back. 
         * @summary Get a paginated list of meeting organizers
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [searchPhrase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meetingOrganizersSearch: async (pageSize: number, page: number, searchPhrase?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('meetingOrganizersSearch', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('meetingOrganizersSearch', 'page', page)
            const localVarPath = `/api/v1/meetings/organizers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve meetings with pagination and optional filtering by status, type, recruitment or date.
         * @summary Get a paginated list of meetings
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {MeetingsSortByDto} [sortBy] 
         * @param {Array<MeetingStatusDto>} [statuses] 
         * @param {string} [searchPhrase] 
         * @param {string} [processId] 
         * @param {string} [externalRecruitmentId] 
         * @param {number} [externalApplicationId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<MeetingDayDto>} [days] Quick day filters. Each selected day is resolved in the application time zone and they are combined with OR, so YESTERDAY and TOMORROW leave today out. Nothing selected means no day filter at all. Ignored when dateFrom or dateTo is given. 
         * @param {Array<string>} [organizers] &#x60;organizerId&#x60; values taken from &#x60;GET /api/v1/meetings/organizers&#x60;, combined with OR. Nothing selected means no organizer filter at all. An id that is not the one the organizers endpoint returned is rejected as a bad request. 
         * @param {MeetingTypeDto} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meetingsSearch: async (pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: MeetingsSortByDto, statuses?: Array<MeetingStatusDto>, searchPhrase?: string, processId?: string, externalRecruitmentId?: string, externalApplicationId?: number, dateFrom?: string, dateTo?: string, days?: Array<MeetingDayDto>, organizers?: Array<string>, type?: MeetingTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('meetingsSearch', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('meetingsSearch', 'page', page)
            const localVarPath = `/api/v1/meetings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            if (processId !== undefined) {
                localVarQueryParameter['processId'] = processId;
            }

            if (externalRecruitmentId !== undefined) {
                localVarQueryParameter['externalRecruitmentId'] = externalRecruitmentId;
            }

            if (externalApplicationId !== undefined) {
                localVarQueryParameter['externalApplicationId'] = externalApplicationId;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (days) {
                localVarQueryParameter['days'] = days.join(COLLECTION_FORMATS.csv);
            }

            if (organizers) {
                localVarQueryParameter['organizers'] = organizers.join(COLLECTION_FORMATS.csv);
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Splits the content from the body with the same rules and the same limit the send uses, so the editor can show the split while the note is still being written. Nothing is stored. 
         * @summary Split edited content without saving it
         * @param {number} meetingId 
         * @param {MeetingNotePartsPreviewRequestDto} meetingNotePartsPreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMeetingNoteParts: async (meetingId: number, meetingNotePartsPreviewRequestDto: MeetingNotePartsPreviewRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('previewMeetingNoteParts', 'meetingId', meetingId)
            // verify required parameter 'meetingNotePartsPreviewRequestDto' is not null or undefined
            assertParamExists('previewMeetingNoteParts', 'meetingNotePartsPreviewRequestDto', meetingNotePartsPreviewRequestDto)
            const localVarPath = `/api/v1/meetings/{meetingId}/note/parts`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingNotePartsPreviewRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only for an INTAKE meeting, typically after it was attached by hand. The meeting goes to TRANSCRIPT_READY while the note is generated and back to NOTE_READY when it is done; the new note becomes the latest one and is offered again as the intake call proposal of the process. When generation fails, the previous note stays and its `generatedAt` does not change. 
         * @summary Generate the intake call note again from the stored transcript, in the background
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateMeetingNote: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('regenerateMeetingNote', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/note/regenerate`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A note longer than the eRecruiter note limit is split into parts and sent in reverse order, so the parts read top down in eRecruiter. 
         * @summary Send the note to eRecruiter as a general candidate note
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMeetingNoteToErecruiter: async (meetingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('sendMeetingNoteToErecruiter', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meetingId}/note/send-to-erecruiter`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pulls the bot list from Recall and creates meetings for bots not present yet. Recovers history recorded outside the calendar flow and repairs missed webhooks. 
         * @summary Import meetings from bots that already exist in Recall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMeetingsFromRecall: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meetings/sync-from-recall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allowed for the author of the feedback and for an admin.
         * @summary Edit recruiter feedback
         * @param {number} meetingId 
         * @param {number} feedbackId 
         * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeetingFeedback: async (meetingId: number, feedbackId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('updateMeetingFeedback', 'meetingId', meetingId)
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('updateMeetingFeedback', 'feedbackId', feedbackId)
            // verify required parameter 'meetingFeedbackRequestDto' is not null or undefined
            assertParamExists('updateMeetingFeedback', 'meetingFeedbackRequestDto', meetingFeedbackRequestDto)
            const localVarPath = `/api/v1/meetings/{meetingId}/feedbacks/{feedbackId}`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)))
                .replace('{feedbackId}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingFeedbackRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit a meeting note\'s content
         * @param {number} meetingId 
         * @param {UpdateMeetingNoteRequestDto} updateMeetingNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeetingNote: async (meetingId: number, updateMeetingNoteRequestDto: UpdateMeetingNoteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('updateMeetingNote', 'meetingId', meetingId)
            // verify required parameter 'updateMeetingNoteRequestDto' is not null or undefined
            assertParamExists('updateMeetingNote', 'updateMeetingNoteRequestDto', updateMeetingNoteRequestDto)
            const localVarPath = `/api/v1/meetings/{meetingId}/note`
                .replace('{meetingId}', encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMeetingNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingsRestApi - functional programming interface
 */
export const MeetingsRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingsRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add recruiter feedback to a meeting
         * @param {number} meetingId 
         * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMeetingFeedback(meetingId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingFeedbackDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMeetingFeedback(meetingId, meetingFeedbackRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.addMeetingFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fallback for a meeting the title marker or the eRecruiter link did not connect. Sets the process, the meeting type and, when missing, the eRecruiter recruitment id of the process. 
         * @summary Attach a meeting that has no process to a process by hand
         * @param {number} meetingId 
         * @param {AttachMeetingToProcessRequestDto} attachMeetingToProcessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachMeetingToProcess(meetingId: number, attachMeetingToProcessRequestDto: AttachMeetingToProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachMeetingToProcess(meetingId, attachMeetingToProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.attachMeetingToProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The owner is the recruiter who organised the meeting. Only the current owner or an administrator can change it; a meeting without an owner can be taken over by any user. 
         * @summary Hand the meeting and its note over to another recruiter
         * @param {number} meetingId 
         * @param {ChangeMeetingOwnerRequestDto} changeMeetingOwnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeMeetingOwner(meetingId: number, changeMeetingOwnerRequestDto: ChangeMeetingOwnerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeMeetingOwner(meetingId, changeMeetingOwnerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.changeMeetingOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get meeting details
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeeting(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeeting(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the notes, the feedback and the transcript as one PDF
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingDocumentPdf(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingDocumentPdf(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingDocumentPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bot and system activity recorded for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingEvents(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingEvents(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the recruiter feedback left for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingFeedbacks(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingFeedbacksDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingFeedbacks(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingFeedbacks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the latest AI note for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingNote(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingNote(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What was actually sent to eRecruiter, per send
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingNoteDeliveries(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingNoteDeliveriesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingNoteDeliveries(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingNoteDeliveries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the parts the note would be delivered in, each one with the marker it will carry and its length, so a recruiter sees what lands in eRecruiter before anything is sent. 
         * @summary The stored note split exactly the way a send would split it
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingNoteParts(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingNotePartsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingNoteParts(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingNoteParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a meeting note as PDF
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingNotePdf(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingNotePdf(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingNotePdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get meeting transcript (readable text + segments)
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingTranscript(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingTranscriptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingTranscript(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.getMeetingTranscript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The people who created the meetings, taken from the calendar invitations, one entry per address and display name, sorted by surname ascending. Feeds the organizer drop-down on the meetings list, so it is paginated and searchable: a phrase shorter than two characters is ignored and the whole list comes back. 
         * @summary Get a paginated list of meeting organizers
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [searchPhrase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meetingOrganizersSearch(pageSize: number, page: number, searchPhrase?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingOrganizersSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meetingOrganizersSearch(pageSize, page, searchPhrase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.meetingOrganizersSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve meetings with pagination and optional filtering by status, type, recruitment or date.
         * @summary Get a paginated list of meetings
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {MeetingsSortByDto} [sortBy] 
         * @param {Array<MeetingStatusDto>} [statuses] 
         * @param {string} [searchPhrase] 
         * @param {string} [processId] 
         * @param {string} [externalRecruitmentId] 
         * @param {number} [externalApplicationId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<MeetingDayDto>} [days] Quick day filters. Each selected day is resolved in the application time zone and they are combined with OR, so YESTERDAY and TOMORROW leave today out. Nothing selected means no day filter at all. Ignored when dateFrom or dateTo is given. 
         * @param {Array<string>} [organizers] &#x60;organizerId&#x60; values taken from &#x60;GET /api/v1/meetings/organizers&#x60;, combined with OR. Nothing selected means no organizer filter at all. An id that is not the one the organizers endpoint returned is rejected as a bad request. 
         * @param {MeetingTypeDto} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meetingsSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: MeetingsSortByDto, statuses?: Array<MeetingStatusDto>, searchPhrase?: string, processId?: string, externalRecruitmentId?: string, externalApplicationId?: number, dateFrom?: string, dateTo?: string, days?: Array<MeetingDayDto>, organizers?: Array<string>, type?: MeetingTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsSearch(pageSize, page, sortOrder, sortBy, statuses, searchPhrase, processId, externalRecruitmentId, externalApplicationId, dateFrom, dateTo, days, organizers, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.meetingsSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Splits the content from the body with the same rules and the same limit the send uses, so the editor can show the split while the note is still being written. Nothing is stored. 
         * @summary Split edited content without saving it
         * @param {number} meetingId 
         * @param {MeetingNotePartsPreviewRequestDto} meetingNotePartsPreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewMeetingNoteParts(meetingId: number, meetingNotePartsPreviewRequestDto: MeetingNotePartsPreviewRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingNotePartsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewMeetingNoteParts(meetingId, meetingNotePartsPreviewRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.previewMeetingNoteParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only for an INTAKE meeting, typically after it was attached by hand. The meeting goes to TRANSCRIPT_READY while the note is generated and back to NOTE_READY when it is done; the new note becomes the latest one and is offered again as the intake call proposal of the process. When generation fails, the previous note stays and its `generatedAt` does not change. 
         * @summary Generate the intake call note again from the stored transcript, in the background
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateMeetingNote(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateMeetingNote(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.regenerateMeetingNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A note longer than the eRecruiter note limit is split into parts and sent in reverse order, so the parts read top down in eRecruiter. 
         * @summary Send the note to eRecruiter as a general candidate note
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMeetingNoteToErecruiter(meetingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMeetingNoteToErecruiter(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.sendMeetingNoteToErecruiter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pulls the bot list from Recall and creates meetings for bots not present yet. Recovers history recorded outside the calendar flow and repairs missed webhooks. 
         * @summary Import meetings from bots that already exist in Recall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncMeetingsFromRecall(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsImportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncMeetingsFromRecall(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.syncMeetingsFromRecall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allowed for the author of the feedback and for an admin.
         * @summary Edit recruiter feedback
         * @param {number} meetingId 
         * @param {number} feedbackId 
         * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMeetingFeedback(meetingId: number, feedbackId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingFeedbackDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMeetingFeedback(meetingId, feedbackId, meetingFeedbackRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.updateMeetingFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit a meeting note\'s content
         * @param {number} meetingId 
         * @param {UpdateMeetingNoteRequestDto} updateMeetingNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMeetingNote(meetingId: number, updateMeetingNoteRequestDto: UpdateMeetingNoteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMeetingNote(meetingId, updateMeetingNoteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsRestApi.updateMeetingNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingsRestApi - factory interface
 */
export const MeetingsRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingsRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Add recruiter feedback to a meeting
         * @param {number} meetingId 
         * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMeetingFeedback(meetingId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFeedbackDto> {
            return localVarFp.addMeetingFeedback(meetingId, meetingFeedbackRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Fallback for a meeting the title marker or the eRecruiter link did not connect. Sets the process, the meeting type and, when missing, the eRecruiter recruitment id of the process. 
         * @summary Attach a meeting that has no process to a process by hand
         * @param {number} meetingId 
         * @param {AttachMeetingToProcessRequestDto} attachMeetingToProcessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachMeetingToProcess(meetingId: number, attachMeetingToProcessRequestDto: AttachMeetingToProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.attachMeetingToProcess(meetingId, attachMeetingToProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The owner is the recruiter who organised the meeting. Only the current owner or an administrator can change it; a meeting without an owner can be taken over by any user. 
         * @summary Hand the meeting and its note over to another recruiter
         * @param {number} meetingId 
         * @param {ChangeMeetingOwnerRequestDto} changeMeetingOwnerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMeetingOwner(meetingId: number, changeMeetingOwnerRequestDto: ChangeMeetingOwnerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeMeetingOwner(meetingId, changeMeetingOwnerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get meeting details
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeeting(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingDetailsDto> {
            return localVarFp.getMeeting(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the notes, the feedback and the transcript as one PDF
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingDocumentPdf(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMeetingDocumentPdf(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bot and system activity recorded for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingEvents(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingEventsDto> {
            return localVarFp.getMeetingEvents(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the recruiter feedback left for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingFeedbacks(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFeedbacksDto> {
            return localVarFp.getMeetingFeedbacks(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the latest AI note for a meeting
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNote(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNoteDto> {
            return localVarFp.getMeetingNote(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What was actually sent to eRecruiter, per send
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNoteDeliveries(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNoteDeliveriesDto> {
            return localVarFp.getMeetingNoteDeliveries(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the parts the note would be delivered in, each one with the marker it will carry and its length, so a recruiter sees what lands in eRecruiter before anything is sent. 
         * @summary The stored note split exactly the way a send would split it
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNoteParts(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNotePartsDto> {
            return localVarFp.getMeetingNoteParts(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a meeting note as PDF
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingNotePdf(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getMeetingNotePdf(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get meeting transcript (readable text + segments)
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingTranscript(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingTranscriptDto> {
            return localVarFp.getMeetingTranscript(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * The people who created the meetings, taken from the calendar invitations, one entry per address and display name, sorted by surname ascending. Feeds the organizer drop-down on the meetings list, so it is paginated and searchable: a phrase shorter than two characters is ignored and the whole list comes back. 
         * @summary Get a paginated list of meeting organizers
         * @param {number} pageSize 
         * @param {number} page 
         * @param {string} [searchPhrase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meetingOrganizersSearch(pageSize: number, page: number, searchPhrase?: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingOrganizersSearchResponseDto> {
            return localVarFp.meetingOrganizersSearch(pageSize, page, searchPhrase, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve meetings with pagination and optional filtering by status, type, recruitment or date.
         * @summary Get a paginated list of meetings
         * @param {number} pageSize 
         * @param {number} page 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {MeetingsSortByDto} [sortBy] 
         * @param {Array<MeetingStatusDto>} [statuses] 
         * @param {string} [searchPhrase] 
         * @param {string} [processId] 
         * @param {string} [externalRecruitmentId] 
         * @param {number} [externalApplicationId] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<MeetingDayDto>} [days] Quick day filters. Each selected day is resolved in the application time zone and they are combined with OR, so YESTERDAY and TOMORROW leave today out. Nothing selected means no day filter at all. Ignored when dateFrom or dateTo is given. 
         * @param {Array<string>} [organizers] &#x60;organizerId&#x60; values taken from &#x60;GET /api/v1/meetings/organizers&#x60;, combined with OR. Nothing selected means no organizer filter at all. An id that is not the one the organizers endpoint returned is rejected as a bad request. 
         * @param {MeetingTypeDto} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meetingsSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: MeetingsSortByDto, statuses?: Array<MeetingStatusDto>, searchPhrase?: string, processId?: string, externalRecruitmentId?: string, externalApplicationId?: number, dateFrom?: string, dateTo?: string, days?: Array<MeetingDayDto>, organizers?: Array<string>, type?: MeetingTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingsSearchResponseDto> {
            return localVarFp.meetingsSearch(pageSize, page, sortOrder, sortBy, statuses, searchPhrase, processId, externalRecruitmentId, externalApplicationId, dateFrom, dateTo, days, organizers, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Splits the content from the body with the same rules and the same limit the send uses, so the editor can show the split while the note is still being written. Nothing is stored. 
         * @summary Split edited content without saving it
         * @param {number} meetingId 
         * @param {MeetingNotePartsPreviewRequestDto} meetingNotePartsPreviewRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMeetingNoteParts(meetingId: number, meetingNotePartsPreviewRequestDto: MeetingNotePartsPreviewRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNotePartsDto> {
            return localVarFp.previewMeetingNoteParts(meetingId, meetingNotePartsPreviewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Only for an INTAKE meeting, typically after it was attached by hand. The meeting goes to TRANSCRIPT_READY while the note is generated and back to NOTE_READY when it is done; the new note becomes the latest one and is offered again as the intake call proposal of the process. When generation fails, the previous note stays and its `generatedAt` does not change. 
         * @summary Generate the intake call note again from the stored transcript, in the background
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateMeetingNote(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.regenerateMeetingNote(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * A note longer than the eRecruiter note limit is split into parts and sent in reverse order, so the parts read top down in eRecruiter. 
         * @summary Send the note to eRecruiter as a general candidate note
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMeetingNoteToErecruiter(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendMeetingNoteToErecruiter(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pulls the bot list from Recall and creates meetings for bots not present yet. Recovers history recorded outside the calendar flow and repairs missed webhooks. 
         * @summary Import meetings from bots that already exist in Recall
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMeetingsFromRecall(options?: RawAxiosRequestConfig): AxiosPromise<MeetingsImportResultDto> {
            return localVarFp.syncMeetingsFromRecall(options).then((request) => request(axios, basePath));
        },
        /**
         * Allowed for the author of the feedback and for an admin.
         * @summary Edit recruiter feedback
         * @param {number} meetingId 
         * @param {number} feedbackId 
         * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeetingFeedback(meetingId: number, feedbackId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFeedbackDto> {
            return localVarFp.updateMeetingFeedback(meetingId, feedbackId, meetingFeedbackRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit a meeting note\'s content
         * @param {number} meetingId 
         * @param {UpdateMeetingNoteRequestDto} updateMeetingNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeetingNote(meetingId: number, updateMeetingNoteRequestDto: UpdateMeetingNoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNoteDto> {
            return localVarFp.updateMeetingNote(meetingId, updateMeetingNoteRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingsRestApi - interface
 */
export interface MeetingsRestApiInterface {
    /**
     * 
     * @summary Add recruiter feedback to a meeting
     * @param {number} meetingId 
     * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addMeetingFeedback(meetingId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFeedbackDto>;

    /**
     * Fallback for a meeting the title marker or the eRecruiter link did not connect. Sets the process, the meeting type and, when missing, the eRecruiter recruitment id of the process. 
     * @summary Attach a meeting that has no process to a process by hand
     * @param {number} meetingId 
     * @param {AttachMeetingToProcessRequestDto} attachMeetingToProcessRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attachMeetingToProcess(meetingId: number, attachMeetingToProcessRequestDto: AttachMeetingToProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * The owner is the recruiter who organised the meeting. Only the current owner or an administrator can change it; a meeting without an owner can be taken over by any user. 
     * @summary Hand the meeting and its note over to another recruiter
     * @param {number} meetingId 
     * @param {ChangeMeetingOwnerRequestDto} changeMeetingOwnerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeMeetingOwner(meetingId: number, changeMeetingOwnerRequestDto: ChangeMeetingOwnerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get meeting details
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeeting(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingDetailsDto>;

    /**
     * 
     * @summary Download the notes, the feedback and the transcript as one PDF
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingDocumentPdf(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Bot and system activity recorded for a meeting
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingEvents(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingEventsDto>;

    /**
     * 
     * @summary List the recruiter feedback left for a meeting
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingFeedbacks(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFeedbacksDto>;

    /**
     * 
     * @summary Get the latest AI note for a meeting
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingNote(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNoteDto>;

    /**
     * 
     * @summary What was actually sent to eRecruiter, per send
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingNoteDeliveries(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNoteDeliveriesDto>;

    /**
     * Returns the parts the note would be delivered in, each one with the marker it will carry and its length, so a recruiter sees what lands in eRecruiter before anything is sent. 
     * @summary The stored note split exactly the way a send would split it
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingNoteParts(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNotePartsDto>;

    /**
     * 
     * @summary Download a meeting note as PDF
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingNotePdf(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get meeting transcript (readable text + segments)
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMeetingTranscript(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingTranscriptDto>;

    /**
     * The people who created the meetings, taken from the calendar invitations, one entry per address and display name, sorted by surname ascending. Feeds the organizer drop-down on the meetings list, so it is paginated and searchable: a phrase shorter than two characters is ignored and the whole list comes back. 
     * @summary Get a paginated list of meeting organizers
     * @param {number} pageSize 
     * @param {number} page 
     * @param {string} [searchPhrase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingOrganizersSearch(pageSize: number, page: number, searchPhrase?: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingOrganizersSearchResponseDto>;

    /**
     * Retrieve meetings with pagination and optional filtering by status, type, recruitment or date.
     * @summary Get a paginated list of meetings
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {MeetingsSortByDto} [sortBy] 
     * @param {Array<MeetingStatusDto>} [statuses] 
     * @param {string} [searchPhrase] 
     * @param {string} [processId] 
     * @param {string} [externalRecruitmentId] 
     * @param {number} [externalApplicationId] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {Array<MeetingDayDto>} [days] Quick day filters. Each selected day is resolved in the application time zone and they are combined with OR, so YESTERDAY and TOMORROW leave today out. Nothing selected means no day filter at all. Ignored when dateFrom or dateTo is given. 
     * @param {Array<string>} [organizers] &#x60;organizerId&#x60; values taken from &#x60;GET /api/v1/meetings/organizers&#x60;, combined with OR. Nothing selected means no organizer filter at all. An id that is not the one the organizers endpoint returned is rejected as a bad request. 
     * @param {MeetingTypeDto} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: MeetingsSortByDto, statuses?: Array<MeetingStatusDto>, searchPhrase?: string, processId?: string, externalRecruitmentId?: string, externalApplicationId?: number, dateFrom?: string, dateTo?: string, days?: Array<MeetingDayDto>, organizers?: Array<string>, type?: MeetingTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingsSearchResponseDto>;

    /**
     * Splits the content from the body with the same rules and the same limit the send uses, so the editor can show the split while the note is still being written. Nothing is stored. 
     * @summary Split edited content without saving it
     * @param {number} meetingId 
     * @param {MeetingNotePartsPreviewRequestDto} meetingNotePartsPreviewRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    previewMeetingNoteParts(meetingId: number, meetingNotePartsPreviewRequestDto: MeetingNotePartsPreviewRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNotePartsDto>;

    /**
     * Only for an INTAKE meeting, typically after it was attached by hand. The meeting goes to TRANSCRIPT_READY while the note is generated and back to NOTE_READY when it is done; the new note becomes the latest one and is offered again as the intake call proposal of the process. When generation fails, the previous note stays and its `generatedAt` does not change. 
     * @summary Generate the intake call note again from the stored transcript, in the background
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regenerateMeetingNote(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * A note longer than the eRecruiter note limit is split into parts and sent in reverse order, so the parts read top down in eRecruiter. 
     * @summary Send the note to eRecruiter as a general candidate note
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendMeetingNoteToErecruiter(meetingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Pulls the bot list from Recall and creates meetings for bots not present yet. Recovers history recorded outside the calendar flow and repairs missed webhooks. 
     * @summary Import meetings from bots that already exist in Recall
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncMeetingsFromRecall(options?: RawAxiosRequestConfig): AxiosPromise<MeetingsImportResultDto>;

    /**
     * Allowed for the author of the feedback and for an admin.
     * @summary Edit recruiter feedback
     * @param {number} meetingId 
     * @param {number} feedbackId 
     * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMeetingFeedback(meetingId: number, feedbackId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFeedbackDto>;

    /**
     * 
     * @summary Edit a meeting note\'s content
     * @param {number} meetingId 
     * @param {UpdateMeetingNoteRequestDto} updateMeetingNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMeetingNote(meetingId: number, updateMeetingNoteRequestDto: UpdateMeetingNoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeetingNoteDto>;

}

/**
 * MeetingsRestApi - object-oriented interface
 */
export class MeetingsRestApi extends BaseAPI implements MeetingsRestApiInterface {
    /**
     * 
     * @summary Add recruiter feedback to a meeting
     * @param {number} meetingId 
     * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addMeetingFeedback(meetingId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).addMeetingFeedback(meetingId, meetingFeedbackRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fallback for a meeting the title marker or the eRecruiter link did not connect. Sets the process, the meeting type and, when missing, the eRecruiter recruitment id of the process. 
     * @summary Attach a meeting that has no process to a process by hand
     * @param {number} meetingId 
     * @param {AttachMeetingToProcessRequestDto} attachMeetingToProcessRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public attachMeetingToProcess(meetingId: number, attachMeetingToProcessRequestDto: AttachMeetingToProcessRequestDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).attachMeetingToProcess(meetingId, attachMeetingToProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The owner is the recruiter who organised the meeting. Only the current owner or an administrator can change it; a meeting without an owner can be taken over by any user. 
     * @summary Hand the meeting and its note over to another recruiter
     * @param {number} meetingId 
     * @param {ChangeMeetingOwnerRequestDto} changeMeetingOwnerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changeMeetingOwner(meetingId: number, changeMeetingOwnerRequestDto: ChangeMeetingOwnerRequestDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).changeMeetingOwner(meetingId, changeMeetingOwnerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get meeting details
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeeting(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeeting(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the notes, the feedback and the transcript as one PDF
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingDocumentPdf(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingDocumentPdf(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bot and system activity recorded for a meeting
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingEvents(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingEvents(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the recruiter feedback left for a meeting
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingFeedbacks(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingFeedbacks(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the latest AI note for a meeting
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingNote(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingNote(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What was actually sent to eRecruiter, per send
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingNoteDeliveries(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingNoteDeliveries(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the parts the note would be delivered in, each one with the marker it will carry and its length, so a recruiter sees what lands in eRecruiter before anything is sent. 
     * @summary The stored note split exactly the way a send would split it
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingNoteParts(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingNoteParts(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a meeting note as PDF
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingNotePdf(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingNotePdf(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get meeting transcript (readable text + segments)
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeetingTranscript(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).getMeetingTranscript(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The people who created the meetings, taken from the calendar invitations, one entry per address and display name, sorted by surname ascending. Feeds the organizer drop-down on the meetings list, so it is paginated and searchable: a phrase shorter than two characters is ignored and the whole list comes back. 
     * @summary Get a paginated list of meeting organizers
     * @param {number} pageSize 
     * @param {number} page 
     * @param {string} [searchPhrase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public meetingOrganizersSearch(pageSize: number, page: number, searchPhrase?: string, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).meetingOrganizersSearch(pageSize, page, searchPhrase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve meetings with pagination and optional filtering by status, type, recruitment or date.
     * @summary Get a paginated list of meetings
     * @param {number} pageSize 
     * @param {number} page 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {MeetingsSortByDto} [sortBy] 
     * @param {Array<MeetingStatusDto>} [statuses] 
     * @param {string} [searchPhrase] 
     * @param {string} [processId] 
     * @param {string} [externalRecruitmentId] 
     * @param {number} [externalApplicationId] 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {Array<MeetingDayDto>} [days] Quick day filters. Each selected day is resolved in the application time zone and they are combined with OR, so YESTERDAY and TOMORROW leave today out. Nothing selected means no day filter at all. Ignored when dateFrom or dateTo is given. 
     * @param {Array<string>} [organizers] &#x60;organizerId&#x60; values taken from &#x60;GET /api/v1/meetings/organizers&#x60;, combined with OR. Nothing selected means no organizer filter at all. An id that is not the one the organizers endpoint returned is rejected as a bad request. 
     * @param {MeetingTypeDto} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public meetingsSearch(pageSize: number, page: number, sortOrder?: SortDirectionDto, sortBy?: MeetingsSortByDto, statuses?: Array<MeetingStatusDto>, searchPhrase?: string, processId?: string, externalRecruitmentId?: string, externalApplicationId?: number, dateFrom?: string, dateTo?: string, days?: Array<MeetingDayDto>, organizers?: Array<string>, type?: MeetingTypeDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).meetingsSearch(pageSize, page, sortOrder, sortBy, statuses, searchPhrase, processId, externalRecruitmentId, externalApplicationId, dateFrom, dateTo, days, organizers, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Splits the content from the body with the same rules and the same limit the send uses, so the editor can show the split while the note is still being written. Nothing is stored. 
     * @summary Split edited content without saving it
     * @param {number} meetingId 
     * @param {MeetingNotePartsPreviewRequestDto} meetingNotePartsPreviewRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewMeetingNoteParts(meetingId: number, meetingNotePartsPreviewRequestDto: MeetingNotePartsPreviewRequestDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).previewMeetingNoteParts(meetingId, meetingNotePartsPreviewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only for an INTAKE meeting, typically after it was attached by hand. The meeting goes to TRANSCRIPT_READY while the note is generated and back to NOTE_READY when it is done; the new note becomes the latest one and is offered again as the intake call proposal of the process. When generation fails, the previous note stays and its `generatedAt` does not change. 
     * @summary Generate the intake call note again from the stored transcript, in the background
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public regenerateMeetingNote(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).regenerateMeetingNote(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A note longer than the eRecruiter note limit is split into parts and sent in reverse order, so the parts read top down in eRecruiter. 
     * @summary Send the note to eRecruiter as a general candidate note
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendMeetingNoteToErecruiter(meetingId: number, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).sendMeetingNoteToErecruiter(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pulls the bot list from Recall and creates meetings for bots not present yet. Recovers history recorded outside the calendar flow and repairs missed webhooks. 
     * @summary Import meetings from bots that already exist in Recall
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public syncMeetingsFromRecall(options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).syncMeetingsFromRecall(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allowed for the author of the feedback and for an admin.
     * @summary Edit recruiter feedback
     * @param {number} meetingId 
     * @param {number} feedbackId 
     * @param {MeetingFeedbackRequestDto} meetingFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMeetingFeedback(meetingId: number, feedbackId: number, meetingFeedbackRequestDto: MeetingFeedbackRequestDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).updateMeetingFeedback(meetingId, feedbackId, meetingFeedbackRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit a meeting note\'s content
     * @param {number} meetingId 
     * @param {UpdateMeetingNoteRequestDto} updateMeetingNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMeetingNote(meetingId: number, updateMeetingNoteRequestDto: UpdateMeetingNoteRequestDto, options?: RawAxiosRequestConfig) {
        return MeetingsRestApiFp(this.configuration).updateMeetingNote(meetingId, updateMeetingNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

